import {SHOWCASE_STAGES, type PackStage} from './packStage'

/**
 * Which frames the pack card can page through, per stage (designer delta §5).
 *
 * Lives outside PackHeroStage so the rule is reachable without mounting the component, and tested
 * there. How the card steps through these frames (`nextLookIndex`) lives in `@core/packs/stage/pager`,
 * shared with the other houses (plan 2026_09_23_pack_stage_coda.md).
 */

export interface PagerLooksInput {
    stage: PackStage
    /** Curated pack samples available at the showcase stages — `pack.rows` flattened. */
    sampleCount: number
    /** Per-slot status for the owner's run, slot order. */
    slotStatuses: readonly (string | undefined)[]
}

/**
 * The reachable frame indices, in paging order. Mirrors what the thumb strip offers at the same
 * stage, so the strip's active border always names what the card shows: the showcase stages page the
 * curated samples, a run pages the slots that are done — which is exactly the set a thumb click
 * accepts.
 *
 * Fewer than two entries means the caller renders no zones at all.
 */
export function pagerLookIndices(input: PagerLooksInput): number[] {
    const {stage, sampleCount, slotStatuses} = input

    if (SHOWCASE_STAGES.includes(stage)) {
        return Array.from({length: sampleCount}, (_, i) => i)
    }
    return slotStatuses.flatMap((status, i) => (status === 'done' ? [i] : []))
}
